import { connect } from 'react-redux';
import { State } from 'widgets/free-content/root/root.reducers';
import FetchEventComponent from './fetch-event.component';
import { Dispatch } from 'types/dispatch';
import { eventFetchData } from 'modules/event-manager/event-manager.actions';

const mapStateToProps = (state: State) => ({
    country: state.IPLocation.data?.countryCode,
    code: state.config.eventCode
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    eventFetchData: (data: { code: string, country: string }) => {
        dispatch(eventFetchData(data));
    }
});

const FetchEventContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FetchEventComponent);

export default FetchEventContainer;
